import { Box, Typography } from '@mui/material';

type PlaceholderKind = 'llm' | 'data';

const STYLES: Record<PlaceholderKind, { bg: string; fg: string; badge: string; defaultText: string }> = {
  llm: {
    bg: 'rgba(31, 31, 112, 0.04)',
    fg: '#3F3F5A',
    badge: 'LLM',
    defaultText: 'Future LLM content will be shown here.',
  },
  data: {
    bg: '#F4F4F8',
    fg: '#5B5B73',
    badge: 'DATA',
    defaultText: 'Data not yet connected.',
  },
};

export function Placeholder({
  kind,
  text,
  height,
  inline,
}: {
  kind: PlaceholderKind;
  text?: string;
  height?: number | string;
  inline?: boolean;
}) {
  const s = STYLES[kind];
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: inline ? 'center' : 'flex-start',
        gap: 1,
        bgcolor: s.bg,
        color: s.fg,
        border: '1px dashed rgba(8, 8, 27, 0.15)',
        borderRadius: 1.5,
        px: 1.5,
        py: inline ? 0.75 : 1.25,
        minHeight: height,
      }}
    >
      <Box
        sx={{
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: 0.6,
          color: '#7A7A93',
          bgcolor: '#FFFFFF',
          border: '1px solid rgba(8, 8, 27, 0.12)',
          borderRadius: 0.75,
          px: 0.75,
          py: 0.25,
          flexShrink: 0,
        }}
      >
        {s.badge}
      </Box>
      <Typography
        sx={{ fontSize: 13, fontStyle: 'italic', lineHeight: 1.5, color: s.fg }}
      >
        {text ?? s.defaultText}
      </Typography>
    </Box>
  );
}

export function LlmPlaceholder({ text, height }: { text?: string; height?: number | string }) {
  return <Placeholder kind="llm" text={text} height={height} />;
}

export function DataPlaceholder({ text, height, inline }: { text?: string; height?: number | string; inline?: boolean }) {
  return <Placeholder kind="data" text={text} height={height} inline={inline} />;
}
